import { EntityContactInformationTaskEditor } from './EntityContactInformationTaskEditor'

export const EntityContactInformationFeatureMap = {
  traitId: 'eqipEntity' as const,
  TaskEditor: EntityContactInformationTaskEditor,
}
